/**
 * Tempo até revogar o object URL de um download avulso: o navegador já leu o blob ao iniciar o
 * download, mas revogar na hora pode abortá-lo em alguns.
 */
export const DOWNLOAD_URL_LIFETIME_MS = 60_000;

/**
 * Salva o arquivo no aparelho com o nome dado. O link é um object URL próprio, e não o da prévia:
 * fechar a tela logo depois de tocar em "Baixar" revoga a prévia sem cortar o download.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_URL_LIFETIME_MS);
}
